module.exports = __webpack_public_path__ + "static/media/IMAGEN-RESOURCES.89a1debf.jpg";